import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'stringOverrides',
  initialState: null as null | Strings,
  reducers: {
    setStringOverrides(state, action: PayloadAction<Strings>) {
      return action.payload || null;
    },
  },
});

export const { setStringOverrides } = slice.actions;

export default slice.reducer;
